import React from 'react';
import './SubcategoriesAction.css';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import classNames from 'classnames';
import { SvgIconMask } from '../../../../../shared/src/components/SvgIconMask';
import downIcon from '../../../../images/subcategories/action-down-arrow.svg';
import { useDeviceTypeHook } from '../../../../../shared/src/hooks/use-device-type.hook';

export const SubcategoriesAction = ({
    onToggle,
    opened,
    iconImage,
    isIconActive,
    labelTranslationKey,
    className = null,
    children,
}) => {
    const { t } = useTranslations();

    const handleShowClick = () => { onToggle(!opened); };
    const { isMobile } = useDeviceTypeHook();
    const iconSize = isMobile ? 12 : 16;

    const wrapperClassName = classNames(
        'asg-subcategories__actions-item',
        className,
        {
            'asg-subcategories__actions-item--opened': opened,
        }
    );
    const iconClassName = classNames(
        'asg-subcategories__actions-item-button-icon',
        {
            'asg-subcategories__actions-item-button-icon--active': isIconActive,
        }
    );
    const caretClassName = classNames(
        'asg-subcategories__actions-item-button-caret',
        {
            'asg-subcategories__actions-item-button-caret--opened': opened,
        },
    );

    return <div className={wrapperClassName}>
        <button className="asg-subcategories__actions-item-button"
            onClick={handleShowClick}
        >
            <span className={iconClassName}>
                <SvgIconMask
                    iconUrl={iconImage}
                    bgColor="var(--cs-body-text-color, #ffffff)"
                    width={iconSize}
                    height={iconSize}
                />
            </span>
            <span className="asg-subcategories__actions-item-button-label">
                {t(labelTranslationKey)}
            </span>
            <SvgIconMask
                iconUrl={downIcon}
                bgColor="var(--cs-body-text-color, #ffffff)"
                width=""
                height=""
                className={caretClassName}
            />
        </button>

        {children}
    </div>;
};
